// extracted by mini-css-extract-plugin
export default {"root":"style_root__zXEk+","icon":"style_icon__Alklp","value":"style_value__RiZt-"};